import GDPRClause from 'components/global/GDPRClause'
import StepHeading from 'components/global/StepHeading'
import Box from 'components/shared/Box'
import { useIntl } from 'react-intl'
import Agreements from 'routes/OrderAndPayment/sections/Agreements'
import SelfcarePlaceOrderSection from './SelfcarePlaceOrderSection'
import { useAppSelector, useAppDispatch } from 'store/hooks'
import VoucherDetails from 'routes/OrderAndPayment/sections/VoucherDetails/VoucherDetails'
import { useEffect, useState } from 'react'
import { useSelfcareCart } from 'store/selfcare-cart-slice/hooks'
import { setErrors } from 'store/order-slice'
import { selfcareFirstStep } from 'routes/basenames'
import Loader from 'components/shared/Loader'
import Section from 'components/shared/Section'

const OrderAndPayment = () => {
    const dispatch = useAppDispatch()
    const { formatMessage } = useIntl()
    const { refetchSelfcareCart, isSelfcareCartFetching } = useSelfcareCart()

    const { cartId, refundPrice, countChanges, countNewItems } = useAppSelector(
        (state) => state.selfcareCart
    )

    const [isDataLoading, setIsDataLoading] = useState(true)

    useEffect(() => {
        dispatch(setErrors([]))
        refetchSelfcareCart()
    }, [])

    useEffect(() => {
        if (!cartId || isSelfcareCartFetching) return

        if (!countChanges && !countNewItems)
            window.location.href = selfcareFirstStep
        else setIsDataLoading(false)
    }, [cartId, isSelfcareCartFetching])

    return (
        <Box gap={[16, 24]} align="stretch">
            <StepHeading
                title={formatMessage({
                    id: 'global.steps.caption_order',
                    defaultMessage: 'Zamówienie i płatność',
                })}
            />
            {isDataLoading ? (
                <Section>
                    <Loader />
                </Section>
            ) : (
                <>
                    {!!refundPrice && <VoucherDetails />}
                    <Agreements />
                    <SelfcarePlaceOrderSection />
                    <GDPRClause />
                </>
            )}
        </Box>
    )
}

export default OrderAndPayment
